import React from 'react';
import { PdfViewer } from '../shared/PdfViewer';

function ActivityPdfViewer({ fileUrl }) {
  return <PdfViewer fileUrl={fileUrl} variant="dark" />;
}

export default ActivityPdfViewer;
